import { EmptyContent } from '@features/directory/components/EmptyContent';
import { ClearFiltersButton } from '@features/ui-atoms/components/ClearFiltersButton';
import { ListAltOutlined } from '@mui/icons-material';
import { useTheme } from '@mui/joy';
import { useTranslation } from 'next-i18next';

export const NoSstFound = ({ onResetFilters }: { onResetFilters?: () => void }) => {
  const { t } = useTranslation('common');
  const theme = useTheme();

  return (
    <EmptyContent
      icon={<ListAltOutlined sx={{ width: '64px', height: '64px', color: theme.palette.grey3 }} />}
      title={t('ssts.empty.title')}
      description={onResetFilters && t('ssts.empty.description')}
    >
      {onResetFilters && <ClearFiltersButton onClick={onResetFilters} />}
    </EmptyContent>
  );
};
